<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <b-card class="border-11">
        <b-overlay :show="isLoading">
          <div class="form-row">
            <div class="form-group col-md-9">
              <label>E.T.</label>
              <input class="form-control" v-model="model.expediente" readonly/>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-9">
              <label>Descripción</label>
              <input class="form-control" v-model="model.descripcion" readonly/>
            </div>
          </div>
          <b-tabs  card >
            <b-tab title="Copia de presupuesto base">
              <div class="form-row">
                <!--<div class="form-group col-md-2">-->
                <button type="button" v-show="$can('expedientes-modificaciones-agregar')"
                        v-on:click="copiarPartidas"
                        class="btn btn-primary ml-4">
                        <i class="fa fa-copy "></i> Copiar partidas
                </button>
                <button type="button" v-show="$can('expedientes-modificaciones-agregar')"
                        v-on:click="verPartidasHistorial"
                        class="btn btn-primary ml-4"><i class="fa fa-book-reader"></i> Ver partidas
                </button>

                <button type="button" :disabled="!$can('expedientes-modificaciones-actualizar-presupuesto')"
                        v-on:click="actualizarPresupuesto"
                        class="btn btn-primary ml-4"><i class="fa fa-book-reader"></i> Actualizar presupuesto
                </button>
                <!--</div>-->
              </div>
              <hr>

            </b-tab>
          </b-tabs>
          <h4>Total: S/ {{total}}</h4>
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Codigo partida</th>
              <th>Partida</th>
              <th>UM</th>
              <th>Metrado</th>
              <th>C.U.</th>
              <th>Parcial</th>
              <th>Fecha</th>

            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in partidas_historial" :key="index">
              <td>{{row.codigo_partida}}</td>
              <td>{{row.partida}}</td>
              <td>{{row.unidad_medida}}</td>
              <td>{{row.cantidad}}</td>
              <td>{{row.costo_unitario}}</td>
              <td>{{row.subtotal}}</td>
              <td>{{row.created_at}}</td>

            </tr>
            </tbody>
          </table>
        </b-overlay>

      </b-card>
  </Layout>





</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

export default {

  page: {
    title: "Modificaciones de expediente técnico",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  name: "modificaciones-expediente-tecnico",
  data(){
    return {
      title: "Expediente técnico",
      items: [
        {
          text: "Expediente tecnico",
          href: "/",
        },
        {
          text: "Modificar",
          active: true,
        },
      ],
      isLoading:false,
      model: {
        descripcion:'',
      },
      total:0,
      isLoadingModal:false,
      partidas_historial:[]
    }
  },
  watch:{

  },
  methods:
      {
        actualizarPresupuesto(){
          this.$swal.fire({
            title: '¿Esta seguro?',
            text: "No se puede revertir esta accion!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Si, borralo!'
          }).then((result) => {
            if (result.value) {
              this.isLoading=true;
              this.axios.post(process.env.VUE_APP_BACKEND +'/api/expedientes/modificaciones/actualizar-de-et-modificado',
                  {
                    'expediente_id':this.model.expediente_id,
                    'modificacion_id':this.model.id
                  }
              )
                  .then(()=>{
                    //this.$bvModal.hide("modalPartidas");
                  })
                  .catch(()=>{
                    this.$swal('error','error','error')
                  })
                  .finally(
                      ()=>
                      {
                        this.isLoadingModal=false;
                        this.actualizar();
                      }
                  );
            }
          })
        },
        copiarPartidas(){

          this.$swal.fire({
            title: '¿Esta seguro?',
            text: "No se puede revertir esta accion!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Si, borralo!'
          }).then((result) => {
            if (result.value) {
              this.isLoading=true;
              this.axios.post(process.env.VUE_APP_BACKEND +'/api/expedientes/modificaciones/copiar-partidas',
                  {
                    'expediente_id':this.model.expediente_id,
                    'modificacion_id':this.model.id
                  }
              )
                  .then(()=>{
                    //this.$bvModal.hide("modalPartidas");
                  })
                  .catch(()=>{
                    this.$swal('error','error','error')
                  })
                  .finally(
                      ()=>
                      {
                        this.isLoadingModal=false;
                        this.actualizar();
                      }
                  );
            }
          })
        },
        verPartidasHistorial(){
          this.isLoading=true;
          this.partidas_historial=[];
          this.axios.get(process.env.VUE_APP_BACKEND + '/api/expedientes/modificaciones/partidas-historial/'+this.$route.params.id)
              .then( (response)=>
              {
                this.partidas_historial=response.data.partidas;
                this.total=response.data.total;
                this.cargarPartidas();
              }).finally(()=>this.isLoading=false);

        },


        actualizar(){
          this.isLoading=true;
          this.axios.get(process.env.VUE_APP_BACKEND + '/api/expedientes/modificaciones/'+this.$route.params.id)
              .then( (response)=>
              {
                this.model=response.data;
                this.cargarPartidas();
              }).finally(()=>this.isLoading=false);
        },

      },
  mounted() {
    if(!isNaN(this.$route.params.id))
    {
      this.actualizar();
    }
    else
    {
      this.$swal('error','error','error');
    }
  },
  validations: {
  },
}
</script>

<style scoped>
.border-11{
  border: 1px solid #b0b0b0;

}

</style>
